import { RowProps as AntdRowProps } from "antd";

export type RowProps = AntdRowProps & {};

export type DefaultRowProps = {};

export const defaultProps: DefaultRowProps = {};
